import React from "react";
import { Tabs } from "antd";
import { PosProduct } from "../../../../Types";
import { ProductCard } from "./ProductCard";

interface TabViewProps {
  categories: { id: string; name: string; products: PosProduct[] }[];
  isWholeSale: boolean;
  isCompact: boolean;
  gridClass: string;
  onAdd: (product: PosProduct) => void;
}

export const TabView: React.FC<TabViewProps> = ({
  categories,
  isWholeSale,
  isCompact,
  gridClass,
  onAdd,
}) => {
  return (
    <Tabs
      size="small"
      tabPosition="top"
      className="pos-shortcut-tabs px-3"
      items={categories.map((cat) => ({
        key: cat.id,
        label: (
          <span className="text-sm font-semibold px-0.5">
            {cat.name}
            <span className="ml-1 text-sm text-gray-400 font-normal">
              ({cat.products.length})
            </span>
          </span>
        ),
        children: (
          <div className={`px-3 pb-3 pt-1 ${gridClass}`}>
            {cat.products.map((p) => (
              <ProductCard
                key={p.id}
                product={p}
                isWholeSale={isWholeSale}
                compact={isCompact}
                onAdd={onAdd}
              />
            ))}
          </div>
        ),
      }))}
    />
  );
};
